const ACTIONS = {
  SET_PERSONAL_INFO: 'setPersonalInfo',
  SET_HOUSEHOLD_INFO: 'setHouseholdInfo',
  SET_GOALS: 'setGoals',
  RESET_FORM: 'resetForm',
};

export default ACTIONS;
